import { render } from "./Roll.vue?vue&type=template&id=e2acd1c2&scoped=true"
import script from "./Roll.vue?vue&type=script&lang=js"
export * from "./Roll.vue?vue&type=script&lang=js"

import "./Roll.vue?vue&type=style&index=0&id=e2acd1c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2acd1c2"]])

export default __exports__